// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

import { sprintf } from '@wordpress/i18n';

import { restCall, handleFatalError, supportLink } from '../common/utilities.js';

export default class Tags {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		// Get elements
		this.getElements();

		// Check if the required elements exist before adding
		// the event listeners
		if ( this.$elements.tagsTextarea.length == 1 ) {
			// Listen modifications to the textarea
			this.listenModificationsToTags();
		}
	}

	getElements() {
		this.$elements = {
			container: $( '#tagsdiv-recipe_tag' ),
			tagsTextarea: $( 'textarea#tax-input-recipe_tag' ),
			tagsList: $( '#tagsdiv-recipe_tag .tagchecklist' ),
		};
	}

	listenModificationsToTags() {
		// Listen when the user adds a new tag. This will be
		// triggered when the user uses the input to add tags
		new MutationObserver( ( mutations ) => {
			// Save tags
			this.saveTags();
		} ).observe( this.$elements.tagsList[ 0 ], {
			childList: true,
		} );
	}

	saveTags() {
		// Get tags
		const tags = this.getTags();

		// Set checkbox as loading
		this.setStatus( 'loading', true );

		// Do call
		restCall(
			'set_recipe_terms',
			{
				term_id: 'recipe_tag',
				recipe_id: UncannyAutomator.recipe.id,
				tags: tags,
			},
			( response ) => {
				// If the call (not necessarily the task) was successful...

				if ( response.success ) {
					// If everything went well...
					// Show a green check icon
					this.setStatus( 'success', true );

					// Remove it after 2 seconds
					setTimeout( () => {
						// Remove the green check icon
						this.setStatus( 'success', false );
					}, 2000 );
				} else {
					// Handle error by showing a modal with data
					handleFatalError({
						title:   UncannyAutomator.i18n.debugging.fatalErrorHandler.exceptions.tags.couldNotSave,
						warning: sprintf(
							UncannyAutomator.i18n.debugging.fatalErrorHandler.generic.content,
							`<a href="${ supportLink() }" target="_blank">${ UncannyAutomator.i18n.debugging.automatorSupport }</a>`
						),
						content: '',
						console: `Data sent:\n ${ JSON.stringify( response ) }`,
						buttons: {
							confirm: null,
							cancel: {
								label: UncannyAutomator.i18n.close,
								onClick: ( $modal ) => {
									// Destroy modal
									$modal.destroy();
								},
							},
						}
					});
				}

				// Remove loading animation
				this.setStatus( 'loading', false );
			},
			( response ) => {
				// On error...

				// Handle error by showing a modal with data
				handleFatalError({
					title:   UncannyAutomator.i18n.debugging.fatalErrorHandler.exceptions.tags.couldNotSave,
					warning: sprintf(
						UncannyAutomator.i18n.debugging.fatalErrorHandler.generic.content,
						`<a href="${ supportLink() }" target="_blank">${ UncannyAutomator.i18n.debugging.automatorSupport }</a>`
					),
					content: '',
					console: `Data sent:\n ${ JSON.stringify( response ) }`,
					buttons: {
						confirm: null,
						cancel: {
							label: UncannyAutomator.i18n.close,
							onClick: ( $modal ) => {
								// Destroy modal
								$modal.destroy();
							},
						},
					}
				});
			},
			{
				requiresRecipesObject: false,
				renderUI: false,
			}
		);
	}

	setStatus( status = '', enable = true ) {
		// Check what status we have to set or unset
		if ( status == 'loading' ) {
			// Check if we have to add or remove the loading status
			if ( enable ) {
				// Add loading animation
				this.$elements.container.addClass( 'uap-tags-loading' );
			} else {
				// Remove loading animation
				this.$elements.container.removeClass( 'uap-tags-loading' );
			}
		} else if ( status == 'success' ) {
			// Check if we have to add or remove the loading status
			if ( enable ) {
				// Add loading animation
				this.$elements.container.addClass( 'uap-tags-success' );
			} else {
				// Remove loading animation
				this.$elements.container.removeClass( 'uap-tags-success' );
			}
		} else if ( status == 'error' ) {
			// Check if we have to add or remove the loading status
			if ( enable ) {
				// Add loading animation
				this.$elements.container.addClass( 'uap-tags-error' );
			} else {
				// Remove loading animation
				this.$elements.container.removeClass( 'uap-tags-error' );
			}
		}
	}

	getTags() {
		// Get tags separated by comma
		const tagsCommaSeparated = this.$elements.tagsTextarea.val();

		// Create array
		const tagsArray = tagsCommaSeparated.split( ',' );

		// Return both
		return {
			asArray: tagsArray,
			commaSeparated: tagsCommaSeparated,
		};
	}
}
